import { useCurrentUserId } from '@hooks/shared/useCurrentUserId';
import { useGetProjectsQuery } from '@lib/redux.lib/slices/projects/projectsApiSlice';

type UseGetProjects = {
  projects: ProjectWithAddress[];
  isLoading: boolean;
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
  refetch: () => void;
};

export const useGetProjects = (): UseGetProjects => {
  const currentUserId = useCurrentUserId();
  const {
    data: projects = [],
    isLoading,
    isFetching,
    isSuccess,
    isError,
    refetch,
  } = useGetProjectsQuery(currentUserId, { skip: !currentUserId });

  return { projects, isLoading, isFetching, isSuccess, isError, refetch };
};
